export const roleData = [
  {
    role: 'Admin',
  },
  {
    role: 'Superuser',
  },
]

export const conditionType = ['Available', 'MaxQuantity']
